import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { addHoliday, updateHoliday } from '../../Services/Holiday/action';
import { toast } from 'react-toastify';

const AddEditHoliday = (props) => {
     const location = useLocation();
     const data = location?.state?.data?.allData;
     const [joiningDate, setJoiningDate] = useState(data?.date || null);
     const [occasion, setOccasion] = useState(data?.occasion || '');
     const navigate = useNavigate();

     const handleAdd = async () => {
          if (!joiningDate || !occasion.trim()) {
               toast.error("Please fill in all required fields.")
               return;
          }
          try {
               const body = {
                    date: joiningDate,
                    occasion
               }

               if (data) {
                    await props?.updateHoliday(data?.id, body);
               }
               else {
                    await props?.addHoliday(body);
               }
               navigate(-1)
          } catch (error) {
               console.error("Error adding holiday :", error)
          }
     }

     return (
               <div className='add-edit-container'>

                    <div className="page-title">
                         <h4>Add Holiday</h4>
                         <div className="edit-btn">
                              <button
                                   type="submit"
                                   className="custom-btn"
                                   onClick={() => navigate(-1)}
                              >
                                   Cancel
                              </button>

                              <button
                                   type="submit"
                                   className="custom-btn"
                                   onClick={handleAdd}
                              >
                                   Save
                              </button>
                         </div>
                    </div>

                    <div className='form-part'>

                         <form>
                              <div className="input-group">
                                   <label htmlFor="joiningDate">Date<span style={{color:"red"}}>*</span></label>
                                   <DatePicker
                                        id="joiningDate"
                                        selected={joiningDate ? new Date(joiningDate) : null}
                                        onChange={(date) => {
                                             const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                                  .toISOString()
                                                  .split('T')[0];
                                             setJoiningDate(date ? localDate : null)
                                        }}
                                        dateFormat="dd-MM-yyyy"
                                        className="form-control"
                                        placeholderText="Enter Date"
                                   />
                              </div>

                              <div className="input-group mt-3">
                                   <h6 className='label'>Occasion<span style={{color:"red"}}>*</span></h6>
                                   <input type="text" className="input-css" name='occasion' placeholder='Enter Occasion'
                                        value={occasion}
                                        onChange={(e) => {
                                             setOccasion(e.target.value)
                                        }} />
                              </div>

                         </form>
                    </div>
               </div>
     )
}

const mapStateToProps = (state) => {
     return {
          holiday: state.holidayReducer.holiday,
          loading: state.holidayReducer.loading,
     }
}

const mapDispatchToProps = (dispatch) => {
     return {
          addHoliday: (data) => {
               dispatch(addHoliday(data))
          },
          updateHoliday: (id, data) => {
               dispatch(updateHoliday(id, data))
          }
     }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEditHoliday);